import React from 'react';
import type { Organism } from '@verndale/core';
import globModules from './glob-modules';
import { renderElement } from './helpers/react-18-shim';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
const reactModule = (Component: any, nodeList: NodeListOf<HTMLElement>) => {
  return nodeList.forEach(node => {
    renderElement(<Component {...node.dataset} />, node);
  });
};

const modules: Organism[] = [
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'reactResultTable',
    loader: () => import('./components/react/ResultTable'),
    render: reactModule
  },
  {
    name: 'wasthishelpful',
    loader: () => import('./modules/wasThisHelpful')
  },
  {
    name: 'testimonialsCarousel',
    loader: () => import('./modules/testimonialsCarousel')
  },
  {
    name: 'footnoteSection',
    loader: () => import('./modules/footnote-section')
  },
  {
    name: 'header',
    loader: () => import('./modules/header/header')
  },
  {
    name: 'contentPodExpandCard',
    loader: () => import('./modules/content-pod-expand-card')
  },
  {
    name: 'blogFeaturedPodGraphQL',
    loader: () => import('./modules/BlogFeaturedPodGraphQL'),
    render: reactModule
  },
  {
    name: 'loginModal',
    loader: () => import('./modules/login-modal')
  },
  {
    name: 'exitIntentModal',
    loader: () => import('./modules/exit-intent-modal')
  },
  {
    name: 'areYouMemberModal',
    loader: () => import('./modules/are-you-member-modal')
  },
  {
    name: 'contactUsForm',
    loader: () => import('./modules/contact-us-form')
  },
  {
    name: 'tabContainer',
    loader: () => import('./modules/tab-container')
  },
  {
    name: 'calculator',
    loader: () => import('./modules/Calculator'),
    render: reactModule
  },
  {
    name: 'reactSearchFilters',
    loader: () => import('./components/react/SearchFilters'),
    render: reactModule
  },
  {
    name: 'searchListing',
    loader: () => import('./modules/SearchListing'),
    render: reactModule
  },
  {
    name: 'searchBar',
    loader: () => import('./modules/searchBar')
  },
  {
    name: 'reactSearchBarInput',
    loader: () => import('./components/react/SearchBarInput'),
    render: reactModule
  },
  {
    name: 'reactDoughnutChart',
    loader: () => import('./components/react/DoughnutChart'),
    render: reactModule
  },
  {
    name: 'alertBanner',
    loader: () => import('./components/header/alert-banner')
  },
  {
    name: 'consentBanner',
    loader: () => import('./modules/consent-banner')
  },
  {
    name: 'locationListing',
    loader: () => import('./modules/LocationListing'),
    render: reactModule
  },
  {
    name: 'locationItem',
    loader: () => import('./modules/LocationListing/LocationItem'),
    render: reactModule
  },
  {
    name: 'searchResults',
    loader: () => import('./components/react/SearchResults'),
    render: reactModule
  },
  {
    name: 'pagination',
    loader: () => import('./components/react/Pagination'),
    render: reactModule
  },
  {
    name: 'blogListing',
    loader: () => import('./modules/BlogListing'),
    render: reactModule
  },
  {
    name: 'newsListing',
    loader: () => import('./components/react/NewsListing'),
    render: reactModule
  },
  {
    name: 'socialShareBanner',
    loader: () => import('./modules/socialShareBanner')
  },
  {
    name: 'sendMyResults',
    loader: () => import('./modules/send-my-results-form')
  },
  {
    name: 'locationMap',
    loader: () => import('./modules/locationMap')
  },
  {
    name: 'locationDetailsAccordion',
    loader: () => import('./modules/locationDetailsAccordion')
  },
  {
    name: 'blogSignupForm',
    loader: () => import('./components/blog-signup-form')
  },
  {
    name: 'promoHeader',
    loader: () => import('./modules/promo-header')
  },
  {
    name: 'requestAnAppointmentWithAdv',
    loader: () => import('./modules/request-an-appointment-with-adv')
  },
  {
    name: 'signUpToNewsletterForm',
    loader: () => import('./modules/sign-up-to-newsletter-form')
  },
  {
    name: 'advisorListing',
    loader: () => import('./modules/AdvisorListing'),
    render: reactModule
  },
  {
    name: 'reactHeading',
    loader: () => import('./components/react/Heading'),
    render: reactModule
  },
  {
    name: 'blogFeaturedPod',
    loader: () => import('./modules/blogFeaturedPod')
  },
  {
    name: 'contentPodGroup',
    loader: () => import('./modules/contentPodGroup')
  },
  {
    name: 'promoCallout',
    loader: () => import('./modules/promo-callout')
  },
  {
    name: 'linkParamManager',
    loader: () => import('./modules/link-param-manager')
  }

];

export default [...globModules, ...modules];
